const INIT_STATE = {
  documentsTallies: [],
  getDocumentsTalliesSuccess: "",
  getDocumentsTalliesError: "",

  getDocumentsList: [],
  getDocumentsListSuccess: "",
  getDocumentsListError: "",

  getNewDocumentsList: [],
  getNewDocumentsListSuccess: "",
  getNewDocumentsListError: "",

  getDocument: "",
  getDocumentSuccess: "",
  getDocumentError: "",

  addDocument: "",
  addDocumentSuccess: "",
  addDocumentError: "",

  updateDocumentSuccess: "",
  updateDocumentError: "",

  deleteDocumentSuccess: "",
  deleteDocumentError: "",

  updateApprovalGroup: [],
  updateApprovalGroupSuccess: "",
  updateApprovalGroupError: "",

  addDocComments: [],
  addDocCommentSuccess: "",
  addDocCommentError: "",

  addDocAttachment: [],
  addDocAttachmentSuccess: "",
  addDocAttachmentError: "",

  downloadDocAttachment: "",
  downloadDocAttachmentSuccess: "",
  downloadDocAttachmentError: "",

  updatePrimaryDocumentSuccess: "",
  updatePrimaryDocumentError: "",

  getDocAttachment: "",
  getDocAttachmentSuccess: "",
  getDocAttachmentError: "",

  deleteDocAttachmentSuccess: "",
  deleteDocAttachmentError: "",

  sendDocForApprovalSuccess: "",
  sendDocForApprovalError: "",

  approveDocSuccess: "",
  approveDocError: "",

  declineDocSuccess: "",
  declineDocError: "",

  holdDocumentSuccess: "",
  holdDocumentError: "",

  moveDocumentSuccess: "",
  moveDocumentError: "",

  regenerateDocumentsSignatureSuccess: "",
  regenerateDocumentsSignatureError: "",

  moveToPrevApprover:"",
  moveToPrevApproverSuccess: "",
  moveToPrevApproverError: "",

  moveToNextApprover:"",
  moveToNextApproverSuccess: "",
  moveToNextApproverError: "",

  transferDocument: "",
  transferDocumentSuccess: "",
  transferDocumentError: "",

  resendEmail: [],
  resendEmailSuccess: "",
  resendEmailError: "",
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    //----------------------****Get Documents Tallies****-----------------------------
    case "GET_DOCUMENT_TALLIES_INIT":
      return {
        ...state,
        documentsTallies: [],
        getDocumentsTalliesSuccess: "",
        getDocumentsTalliesError: "",
      };
    case "GET_DOCUMENT_TALLIES_SUCCESS":
      let documentTallies = action.payload.documentTallies || [];

      //changing Drafts to Draft
      documentTallies.map((t, i) => {
        if (t.docState === "Drafts") {
          t.docState = "Draft";
        }
        return t;
      });
      return {
        ...state,
        documentsTallies: documentTallies || [],
        getDocumentsTalliesSuccess: action.payload.result[0].description,
      };
    case "GET_DOCUMENT_TALLIES_FAIL":
      return {
        ...state,
        getDocumentsTalliesError: action.payload,
      };
    //----------------------****Get Documents List****-----------------------------
    case "GET_DOCUMENTS_LIST_INIT":
      return {
        ...state,
        getDocumentsList: [],
        getDocumentsListSuccess: "",
        getDocumentsListError: "",
      };
    case "GET_DOCUMENTS_LIST_SUCCESS":
      return {
        ...state,
        getDocumentsList: action.payload.documentsList || [],
        getDocumentsListSuccess: action.payload.result[0].description,
      };
    case "GET_DOCUMENTS_LIST_FAIL":
      return {
        ...state,
        getDocumentsListError: action.payload,
      };
    //----------------------****Get New Documents List****-----------------------------
    case "GET_NEW_DOCUMENTS_LIST_INIT":
      return {
        ...state,
        getNewDocumentsList: [],
        getNewDocumentsListSuccess: "",
        getNewDocumentsListError: "",
      };
    case "GET_NEW_DOCUMENTS_LIST_SUCCESS":
      return {
        ...state,
        getNewDocumentsList: action.payload || [],
        getNewDocumentsListSuccess: action.payload.result[0].description,
      };
    case "GET_NEW_DOCUMENTS_LIST_FAIL":
      return {
        ...state,
        getNewDocumentsListError: action.payload,
      };
    //----------------------****Get Documents List****-----------------------------
    case "GET_DOCUMENT_INIT":
      return {
        ...state,
        getDocument: "",
        getDocumentSuccess: "",
        getDocumentError: "",
      };
    case "GET_DOCUMENT_SUCCESS":
      return {
        ...state,
        getDocument: action.payload?.document ? action.payload?.document : action.payload.documentSummary || "",
        getDocumentSuccess: action.payload.result[0].description,
      };
    case "GET_DOCUMENT_FAIL":
      return {
        ...state,
        getDocumentError: action.payload,
      };
    
     case "TRANSFER_DOCUMENTS_INIT":
      return {
        ...state,
        transferDocument: "",
        transferDocumentSuccess: "",
        transferDocumentError: "",
      };
    case "TRANSFER_DOCUMENTS_SUCCESS":
      return {
        ...state,
        transferDocument: action.payload.document || "",
        transferDocumentSuccess: action.payload.result[0].description,
      };
    case "TRANSFER_DOCUMENTS_FAIL":
      return {
        ...state,
        transferDocumentError: action.payload,
      };
    //----------------------****Add Document ****-----------------------------
    case "ADD_DOCUMENT_INIT":
      return {
        ...state,
        addDocument: "",
        addDocumentSuccess: "",
        addDocumentError: "",
      };
    case "ADD_DOCUMENT_SUCCESS":
      return {
        ...state,
        addDocument: action.payload.document || "",
        addDocumentSuccess: action.payload.result[0].description,
      };
    case "ADD_DOCUMENT_FAIL":
      return {
        ...state,
        addDocumentError: action.payload,
      };
    //----------------------****Update Document****-----------------------------
    case "UPDATE_DOCUMENT_INIT":
      return {
        ...state,
        updateDocumentSuccess: "",
        updateDocumentError: "",
      };
    case "UPDATE_DOCUMENT_SUCCESS":
      return {
        ...state,
        updateDocumentSuccess: action.payload.result[0].description,
      };
    case "UPDATE_DOCUMENT_FAIL":
      return {
        ...state,
        updateDocumentError: action.payload,
      };
    //----------------------****Delete Document****-----------------------------
    case "DELETE_DOCUMENT_INIT":
      return {
        ...state,
        deleteDocumentSuccess: "",
        deleteDocumentError: "",
      };
    case "DELETE_DOCUMENT_SUCCESS":
      return {
        ...state,
        deleteDocumentSuccess: action.payload.result[0].description,
      };
    case "DELETE_DOCUMENT_FAIL":
      return {
        ...state,
        deleteDocumentError: action.payload,
      };

    //----------------------****Update Approval Group ****-----------------------------
    case "UPDATE_APPROVAL_DOCUMENTS_GROUP_INIT":
      return {
        ...state,
        updateApprovalGroup: [],
        updateApprovalGroupSuccess: "",
        updateApprovalGroupError: "",
      };
    case "UPDATE_APPROVAL_DOCUMENTS_GROUP_SUCCESS":
      return {
        ...state,
        updateApprovalGroup: action.payload || [],
        updateApprovalGroupSuccess: action.payload.result[0].description,
      };
    case "UPDATE_APPROVAL_DOCUMENTS_GROUP_FAIL":
      return {
        ...state,
        updateApprovalGroupError: action.payload,
      };
    //----------------------****Add Comments****-----------------------------
    case "ADD_COMMENT_INIT":
      return {
        ...state,
        addDocComments: [],
        addDocCommentSuccess: "",
        addDocCommentError: "",
      };
    case "ADD_COMMENT_SUCCESS":
      return {
        ...state,
        addDocComments: action.payload.comments || [],
        addDocCommentSuccess: action.payload.result[0].description,
      };
    case "ADD_COMMENT_FAIL":
      return {
        ...state,
        addDocCommentError: action.payload,
      };
    //----------------------****Add Document Attachments****-----------------------------
    case "ADD_DOC_ATTACHMENTS_INIT":
      return {
        ...state,
        addDocAttachment: [],
        addDocAttachmentSuccess: "",
        addDocAttachmentError: "",
      };
    case "ADD_DOC_ATTACHMENTS_SUCCESS":
      return {
        ...state,
        addDocAttachment: action.payload.attachments || [],
        addDocAttachmentSuccess: action.payload.result[0].description,
      };
    case "ADD_DOC_ATTACHMENTS_FAIL":
      return {
        ...state,
        addDocAttachmentError: action.payload,
      };
     //----------------------****Add Document Attachments****-----------------------------
    case "DOWNLOAD_DOC_ATTACHMENTS_INIT":
      return {
        ...state,
        downloadDocAttachment: "",
        downloadDocAttachmentSuccess: "",
        downloadDocAttachmentError: "",
      };
    case "DOWNLOAD_DOC_ATTACHMENTS_SUCCESS":
      return {
        ...state,
        downloadDocAttachment: action.payload || "",
        downloadDocAttachmentSuccess: action.payload.result[0].description,
      };
    case "DOWNLOAD_DOC_ATTACHMENTS_FAIL":
      return {
        ...state,
        downloadDocAttachmentError: action.payload,
      };
    //----------------------****Update Primary Document****-----------------------------
    case "UPDATE_TO_PRIMARY_DOC_DOCUMENTS_INIT":
      return {
        ...state,
        updatePrimaryDocumentSuccess: "",
        updatePrimaryDocumentError: "",
      };
    case "UPDATE_TO_PRIMARY_DOC_DOCUMENTS_SUCCESS":
      return {
        ...state,
        updatePrimaryDocumentSuccess: action.payload.result[0].description,
      };
    case "UPDATE_TO_PRIMARY_DOC_DOCUMENTS_FAIL":
      return {
        ...state,
        updatePrimaryDocumentError: action.payload,
      };
    //----------------------****Get Document Attachment****-----------------------------
    case "GET_DOC_ATTACHMENT_INIT":
      return {
        ...state,
        getDocAttachment: "",
        getDocAttachmentSuccess: "",
        getDocAttachmentError: "",
      };
    case "GET_DOC_ATTACHMENT_SUCCESS":
      return {
        ...state,
        getDocAttachment: action.payload || "",
        getDocAttachmentSuccess: action.payload.result[0].description,
      };
    case "GET_DOC_ATTACHMENT_FAIL":
      return {
        ...state,
        getDocAttachmentError: action.payload,
      };
    //----------------------****Delete Document Attachment****-----------------------------
    case "DELETE_DOC_ATTACHMENT_INIT":
      return {
        ...state,
        deleteDocAttachmentSuccess: "",
        deleteDocAttachmentError: "",
      };
    case "DELETE_DOC_ATTACHMENT_SUCCESS":
      return {
        ...state,
        deleteDocAttachmentSuccess: action.payload.result[0].description,
      };
    case "DELETE_DOC_ATTACHMENT_FAIL":
      return {
        ...state,
        deleteDocAttachmentError: action.payload,
      };
    //----------------------****Send Document For Approval****-----------------------------
    case "SEND_DOC_FOR_APPROVAL_INIT":
      return {
        ...state,
        sendDocForApprovalSuccess: "",
        sendDocForApprovalError: "",
      };
    case "SEND_DOC_FOR_APPROVAL_SUCCESS":
      return {
        ...state,
        sendDocForApprovalSuccess: action.payload.result[0].description,
      };
    case "SEND_DOC_FOR_APPROVAL_FAIL":
      return {
        ...state,
        sendDocForApprovalError: action.payload,
      };
    //----------------------****Approve Document****-----------------------------
    case "APPROVE_DOCUMENT_INIT":
      return {
        ...state,
        approveDocSuccess: "",
        approveDocError: "",
      };
    case "APPROVE_DOCUMENT_SUCCESS":
      return {
        ...state,
        approveDocSuccess: action.payload.result[0].description,
      };
    case "APPROVE_DOCUMENT_FAIL":
      return {
        ...state,
        approveDocError: action.payload,
      };
    //----------------------****Decline Document****-----------------------------
    case "DECLINE_DOCUMENT_INIT":
      return {
        ...state,
        declineDocSuccess: "",
        declineDocError: "",
      };
    case "DECLINE_DOCUMENT_SUCCESS":
      return {
        ...state,
        declineDocSuccess: action.payload.result[0].description,
      };
    case "DECLINE_DOCUMENT_FAIL":
      return {
        ...state,
        declineDocError: action.payload,
      };
    //----------------------****Hold Document****-----------------------------
    case "HOLD_DOCUMENT_INIT":
      return {
        ...state,
        holdDocumentSuccess: "",
        holdDocumentError: "",
      };
    case "HOLD_DOCUMENT_SUCCESS":
      return {
        ...state,
        holdDocumentSuccess: action.payload.result[0].description,
      };
    case "HOLD_DOCUMENT_FAIL":
      return {
        ...state,
        holdDocumentError: action.payload,
      };
    //----------------------****Move Document****-----------------------------
    case "MOVE_DOCUMENT_INIT":
      return {
        ...state,
        moveDocumentSuccess: "",
        moveDocumentError: "",
      };
    case "MOVE_DOCUMENT_SUCCESS":
      return {
        ...state,
        moveDocumentSuccess: action.payload.result[0].description,
      };
    case "MOVE_DOCUMENT_FAIL":
      return {
        ...state,
        moveDocumentError: action.payload,
      };
    case "REGENERATE_DOCUMENTS_INIT":
      return {
        ...state,
        regenerateDocumentsSignatureSuccess: "",
        regenerateDocumentsSignatureError: "",
      };

    case "REGENERATE_DOCUMENTS_SUCCESS":
      return {
        ...state,
        regenerateDocumentsSignatureSuccess:
          action.payload.result[0].description,
      };
    case "REGENERATE_DOCUMENTS_FAILED":
      return {
        ...state,
        regenerateDocumentsSignatureError: action.payload,
      };
    
    case "DOCUMENT_MOVE_TO_NEXT_APPROVER_INIT":
      return {
        ...state,
        moveToNextApprover: "",
        moveToNextApproverSuccess: "",
        moveToNextApproverError: "",
      };
    case "DOCUMENT_MOVE_TO_NEXT_APPROVER_SUCCESS":
      return {
        ...state,
        moveToNextApprover: action.payload,
        moveToNextApproverSuccess: action.payload.result,
      };
    case "DOCUMENT_MOVE_TO_NEXT_APPROVER_FAIL":
      return {
        ...state,
        moveToNextApproverError: action.payload,
      };
    //----------------------**** moveToPrevApprover ****-----------------------------
    case "DOCUMENT_MOVE_TO_PREV_APPROVER_INIT":
      return {
        ...state,
        moveToPrevApprover: "",
        moveToPrevApproverSuccess: "",
        moveToPrevApproverError: "",
      };
    case "DOCUMENT_MOVE_TO_PREV_APPROVER_SUCCESS":
      return {
        ...state,
        moveToPrevApprover: action.payload,
        moveToPrevApproverSuccess: action.payload.result,
      };
    case "DOCUMENT_MOVE_TO_PREV_APPROVER_FAIL":
      return {
        ...state,
        moveToPrevApproverError: action.payload,
      };
    //----------------------****Send Email Approver*****------------------------------
    case "SEND_EMAIL_APPROVER_INIT_DOC":
      return {
        ...state,
        resendEmail: [],
        resendEmailSuccess: "",
        resendEmailError: "",
      };
    case "SEND_EMAIL_APPROVER_SUCCESS_DOC":
      return {
        ...state,
        resendEmail: action.payload || [],
        resendEmailSuccess: action.payload.result[0].description
      };
    case "SEND_EMAIL_APPROVER_FAIL_DOC":
      return {
        ...state,
        resendEmailError: action.payload,
      };

    //----------------------****Clear Documents states****-----------------------------
    case "CLEAR_DOCUMENTS_STATES":
      return {
        ...state,

        getDocumentsTalliesSuccess: "",
        getDocumentsTalliesError: "",

        getDocumentsListSuccess: "",
        getDocumentsListError: "",

        getDocumentSuccess: "",
        getDocumentError: "",

        addDocumentSuccess: "",
        addDocumentError: "",

        updateDocumentSuccess: "",
        updateDocumentError: "",

        deleteDocumentSuccess: "",
        deleteDocumentError: "",

        addDocCommentSuccess: "",
        addDocCommentError: "",

        addDocAttachmentSuccess: "",
        addDocAttachmentError: "",

          downloadDocAttachment: "",
        downloadDocAttachmentSuccess: "",
        downloadDocAttachmentError: "",

        updatePrimaryDocumentSuccess: "",
        updatePrimaryDocumentError: "",

        getDocAttachmentSuccess: "",
        getDocAttachmentError: "",

        deleteDocAttachmentSuccess: "",
        deleteDocAttachmentError: "",

        sendDocForApprovalSuccess: "",
        sendDocForApprovalError: "",

        approveDocSuccess: "",
        approveDocError: "",

        declineDocSuccess: "",
        declineDocError: "",

        holdDocumentSuccess: "",
        holdDocumentError: "",

        moveDocumentSuccess: "",
        moveDocumentError: "",

        moveToPrevApprover: "",
        moveToPrevApproverSuccess: "",
        moveToPrevApproverError: "",

        moveToNextApprover: "",
        moveToNextApproverSuccess: "",
        moveToNextApproverError: "",

        resendEmail: [],
        resendEmailSuccess: "",
        resendEmailError: "",
      };
    //----------------------****Clear States When Producton Login****-----------------------------
    case "CLEAR_STATES_WHEN_LOGIN_PRODUCTION":
      //when user login production on dashboard then remove data of previous Production
      return {
        ...state,

        getDocumentsList: [],
        getDocumentsListSuccess: "",
        getDocumentsListError: "",

        getNewDocumentsList: [],
        getNewDocumentsListSuccess: "",
        getNewDocumentsListError: "",

        getDocument: "",
        getDocumentSuccess: "",
        getDocumentError: "",

        addDocument: "",
        addDocumentSuccess: "",
        addDocumentError: "",

        updateDocumentSuccess: "",
        updateDocumentError: "",

        deleteDocumentSuccess: "",
        deleteDocumentError: "",

        addDocComments: [],
        addDocCommentSuccess: "",
        addDocCommentError: "",

        addDocAttachment: [],
        addDocAttachmentSuccess: "",
        addDocAttachmentError: "",

          downloadDocAttachment: "",
        downloadDocAttachmentSuccess: "",
        downloadDocAttachmentError: "",

        updatePrimaryDocumentSuccess: "",
        updatePrimaryDocumentError: "",

        getDocAttachment: "",
        getDocAttachmentSuccess: "",
        getDocAttachmentError: "",

        deleteDocAttachmentSuccess: "",
        deleteDocAttachmentError: "",

        sendDocForApprovalSuccess: "",
        sendDocForApprovalError: "",

        approveDocSuccess: "",
        approveDocError: "",

        declineDocSuccess: "",
        declineDocError: "",

        holdDocumentSuccess: "",
        holdDocumentError: "",

        moveDocumentSuccess: "",
        moveDocumentError: "",

        moveToPrevApprover: "",
        moveToPrevApproverSuccess: "",
        moveToPrevApproverError: "",

        moveToNextApprover: "",
        moveToNextApproverSuccess: "",
        moveToNextApproverError: "",

        transferDocument: "",
        transferDocumentSuccess: "",
        transferDocumentError: "",

        resendEmail: [],
        resendEmailSuccess: "",
        resendEmailError: "",
      };
    //----------------------****Clear States After Logout****-----------------------------
    case "CLEAR_STATES_AFTER_LOGOUT":
      return {
        ...state,

        documentsTallies: [],
        getDocumentsTalliesSuccess: "",
        getDocumentsTalliesError: "",

        getDocumentsList: [],
        getDocumentsListSuccess: "",
        getDocumentsListError: "",

        getNewDocumentsList: [],
        getNewDocumentsListSuccess: "",
        getNewDocumentsListError: "",

        getDocument: "",
        getDocumentSuccess: "",
        getDocumentError: "",

        addDocument: "",
        addDocumentSuccess: "",
        addDocumentError: "",

        updateDocumentSuccess: "",
        updateDocumentError: "",

        deleteDocumentSuccess: "",
        deleteDocumentError: "",

        addDocComments: [],
        addDocCommentSuccess: "",
        addDocCommentError: "",

        addDocAttachment: [],
        addDocAttachmentSuccess: "",
        addDocAttachmentError: "",

        updatePrimaryDocumentSuccess: "",
        updatePrimaryDocumentError: "",

        getDocAttachment: "",
        getDocAttachmentSuccess: "",
        getDocAttachmentError: "",

        deleteDocAttachmentSuccess: "",
        deleteDocAttachmentError: "",

        sendDocForApprovalSuccess: "",
        sendDocForApprovalError: "",

        approveDocSuccess: "",
        approveDocError: "",

        declineDocSuccess: "",
        declineDocError: "",

        holdDocumentSuccess: "",
        holdDocumentError: "",

        moveDocumentSuccess: "",
        moveDocumentError: "",

        moveToNextApprover: "",
        moveToNextApproverSuccess: "",
        moveToNextApproverError: "",

        moveToPrevApprover: "",
        moveToPrevApproverSuccess: "",
        moveToPrevApproverError: "",

        transferDocument: "",
        transferDocumentSuccess: "",
        transferDocumentError: "",

        resendEmail: [],
        resendEmailSuccess: "",
        resendEmailError: "",
      };
    default:
      return state;
  }
}
